import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { AutoSelectedGenresProps } from './AutoSelectedGenresProps'
import { List } from './styles'

const AutoSelectedGenres: FunctionComponent<AutoSelectedGenresProps> = ({
  autoSelectedGenres,
}) => {
  const { t } = useTranslation()

  const mappedAutoSelectedGenres =
    autoSelectedGenres &&
    autoSelectedGenres.map((item, index, arr) => (
      <li key={item.id}>
        {item.genreName.slice(0, 1).toUpperCase() + item.genreName.slice(1)}
        {index + 1 !== arr.length && ',\u00A0'}
      </li>
    ))

  return (
    <List>
      {autoSelectedGenres && autoSelectedGenres.length > 0 ? (
        <span>{mappedAutoSelectedGenres}</span>
      ) : (
        <li>{t('adminPage.noAutoselectedGenres')}</li>
      )}
    </List>
  )
}
export default AutoSelectedGenres
